module.exports = __webpack_public_path__ + "static/FirstBanner-598a9e6b226c792f02a18c6090239cbf.png";